export default "precision mediump float;\n#define GLSLIFY 1\nattribute vec2 position;\n\nvoid main() {\n  gl_Position = vec4(position, 1., 1.);\n}";